import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationSubscriptionsAddPlan = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
